import {createContext} from 'react';

export const ChronoContext = createContext({hours : 0, minutes : 0, seconds: 0});